/** Affiche les noms de ville en MAJUSCULES (les sources mélangent « MONTPELLIER » et « Montpellier »). */
export function upperCity(city?: string | null): string | null {
  const c = city?.trim();
  return c ? c.toUpperCase() : null;
}
